export default __webpack_public_path__ + "static/media/abc.51bfeac4.png";